import { branch, memberKey } from './constants'
import ConfigQuery from './ConfigQuery'

class ConfigNode extends Weaver.Node

  constructor: (id) ->
    super(id)
    @relation(memberKey).add(@getType())

  @load: (id, NodeClass) ->
    new ConfigQuery()
      .restrict(id)
      .first(NodeClass or @)

  @list: (params = {}) ->
    query = new ConfigQuery()
      .type(@)
      .limit(params.limit or 1000)
      .skip(params.skip or 0)
    query.find(@)

  @getTypeNode: ->
    ConfigNode.get("#{ @className }")

  getType: ->
    ConfigNode.get("#{ @constructor.className }")

  loadFromQuery: ->
    type = @.relation(memberKey).first()
    model[type.id()]

  save: (params) ->
    super({ params..., branch })


export default ConfigNode
